// extracted by mini-css-extract-plugin
export default {"card":"Productlist_card__1t+2l","invisible":"Productlist_invisible__rmO0y"};